import styled from 'styled-components';

export const Container = styled.div`
    display: block;
    max-height: 0;
    padding: 0;
    width: 100%;

    text-align: center;

    overflow: hidden;

    transition: all 0.2s ease;

    &.active {
        max-height: 10000px;
        padding: 60px 0;
    }
`;

export const Title = styled.h3`
    font-size: 25px;
    color: #fff;
`;

export const TrackingContainer = styled.div`
    width: 100%;
    max-width: 600px;
    margin: 0 auto;

    > ul {
        padding: 0 40px;
    }
`;
